import type { Asset, Chain, PennyworksPosition, Vault, VaultTransaction, IVaultHasAssocAddresses, IVaultHasManager, IVaultHasWrapper, IVaultHasNav, IVaultHasNavs, IVaultHasDenomination, IVaultHasChain, IVaultHasTransactions, } from "@bracket/types";
import * as G from "@globals";
import type { IdentifiableVault, } from "@types";
import { isAddress, } from "viem";

export * from "./pennyworks/queries";







/**
 * 
 * @param address 
 * @returns 
 */
export const VAULTS = (address: string) => `
{
	wallet( address: "${address}" ) {
		vaults {
			address
			symbol
			version
			status
		},
		managed_vaults {
			symbol
			address
			version
			status
		}
	}
}
`;


//TODO: parameterize the call to reduce on a single vault, but this is fast enough for now.
export const VAULT_DATA = () => {

	const { address } = G.wallet.getBracketWallet();

	if(!isAddress(address as string))
		throw new Error("vaults:: VAULT_DATA - missing address");

	return `
	{
		wallet(address: "${address}") {
			created
			referee
			referee_id
			safary_id
			claimr_id
			vaults {
				address
				created
				delayed
				status
				kyc_required
				launch_date
				close_date
				name
				title
				header
				header_info
				yield_desc
				fees_desc
				fees_info
				nav_info
				withdrawal_type
				withdrawal_type_info
				term_type
				objective
				nav_launch
				deposit_min
				description
				symbol
				logo
				estimated_performance
				strategy
				manager_fee
				bracket_fee
				tvl_fee
				amount_available
				fee_method
				epoch
				epoch_offset_hours
				enforced_capabilities
				version
				expected_lock_hours
				epoch_duration_days
				deposit_type
				deposit_type_info
				nav_update_schedule
				nav_update_schedule_info
				live
				looping
				withdraw_delay_days
				bracket_claim_address
				manager_claim_address
				nav_updater_address
				kyc_required
				kyc_active
				kyc_tier
				kyc_templates
				kyb_available
				kyb_required
				kyb_min_tier
				kyb_templates
				morpho_url
				assoc_addresses {
					address
					type
					name
				}
				chain {
					id
					name
					logo
				}
				denomination {
					id
					name
					symbol
					logo
					label
					address
					decimals
					apy_prefix
					chainId
				}
				nav {
					epoch
					nav
					onav
					manager_tvl_fee
					bracket_tvl_fee
					manager_performance_fee
					created
					updated
				}
				navs {
					epoch
					nav
					onav
					block
					epoch_duration_days
					created
					updated
				}
				manager {
					address
					user {
						email
						company
					}
				}
				transactions {
					chain
					block
					log_index
					transaction_hash
					trxn_type
					vault_address
					created
					nav
					onav
					shares
					amount_eq
					amount_brkt
					brkt_claimed
					finalized
					brkteth_conv
					price_btc
					price_eth
					finalized
					scheduled_time
					hash
					salt
					epoch_available
					pnl
					share_price_usd
				}
				wrapper {
					address
					symbol
					logo
					label
					name
					decimals
				}
				morpho_data {
					lltv
					leverage
					leveragedYield
					borrowYield
				}
			}
		}
	}
`;
};


export const VAULTS_WITH_TRANSACTIONS = (address: string) => `
	{
		wallet(address: "${address}") {
			created
			referee
			referee_id
			safary_id
			claimr_id
			vaults {
				address
				delayed
				chain {
					id
				}
				created
				status
				launch_date
				close_date
				name
				title
				header
				header_info
				yield_desc
				fees_desc
				fees_info
				nav_info
				withdrawal_type
				withdrawal_type_info
				term_type
				objective
				nav_launch
				deposit_min
				description
				symbol
				logo
				live
				looping
				estimated_performance
				strategy
				manager_fee
				bracket_fee
				tvl_fee
				amount_available
				fee_method
				epoch
				epoch_offset_hours
				enforced_capabilities
				version
				expected_lock_hours
				epoch_duration_days
				withdraw_delay_days
				kyc_required
				kyc_active
				kyc_tier
				kyc_templates
				kyb_available
				kyb_required
				kyb_min_tier
				kyb_templates
				morpho_url
				assoc_addresses {
					address
					type
					name
				}
				nav {
					epoch
					nav
					onav
					manager_tvl_fee
					bracket_tvl_fee
					manager_performance_fee
					updated
				}
				navs {
					epoch
					nav
					onav
				}
				manager {
					address
					user {
						email
						company
					}
				}
				transactions {
					trxn_type
					created
					nav
					onav
					shares
					amount_eq
					amount_brkt
					brkt_claimed
					finalized
					brkteth_conv
					price_btc
					price_eth
					finalized
					scheduled_time
					hash
					salt
					epoch_available
				}
				morpho_data {
					lltv
					leverage
					leveragedYield
					borrowYield
				}
			}
		}
	}
`;


export const MANAGED_VAULT = ( symbol: Vault["symbol"] ) => `
	{
		managed_vault(symbol: "${symbol}") {
			address
			delayed
			chain {
				id
			}
			created
			status
			launch_date
			close_date
			name
			title
			header
			header_info
			yield_desc
			fees_desc
			fees_info
			nav_info
			withdrawal_type
			withdrawal_type_info
			term_type
			objective
			nav_launch
			deposit_min
			description
			symbol
			logo
			live
			looping
			estimated_performance
			strategy
			manager_fee
			bracket_fee
			tvl_fee
			amount_available
			fee_method
			epoch
			epoch_offset_hours
			enforced_capabilities
			version
			expected_lock_hours
			epoch_duration_days
			bracket_claim_address
			manager_claim_address
			nav_updater_address
			withdraw_delay_days
			kyc_required
			kyc_active
			kyc_tier
			kyc_templates
			kyb_available
			kyb_required
			kyb_min_tier
			kyb_templates
			morpho_url
			assoc_addresses {
				address
				type
				name
			}
			denomination {
				id
				name
				symbol
				logo
				label
				address
				decimals
				apy_prefix
				chainId
			}
			nav {
				epoch
				nav
				onav
				manager_tvl_fee
				bracket_tvl_fee
				manager_performance_fee
				updated
			}
			navs {
				epoch
				nav
				onav
				epoch_duration_days
			}
			manager {
				address
				user {
					email
					company
				}
			}
			wrapper {
				address
				symbol
				logo
				label
				name
				decimals
			}
			morpho_data {
				lltv
				leverage
				leveragedYield
				borrowYield
			}
		}
	}
`;


export const MANAGED_VAULT_DATA = () => {

	const { address } = G.wallet.getBracketWallet();
	if(!isAddress(address as string))
		throw new Error("vaults:: VAULT_DATA - missing address");

	return `
	{
		wallet(address: "${address}") {
			managed_vaults {
				address
				delayed
				chain {
					id
				}
				created
				status
				launch_date
				close_date
				name
				title
				header
				header_info
				yield_desc
				fees_desc
				fees_info
				nav_info
				withdrawal_type
				withdrawal_type_info
				term_type
				objective
				nav_launch
				deposit_min
				description
				symbol
				logo
				live
				looping
				estimated_performance
				strategy
				manager_fee
				bracket_fee
				tvl_fee
				amount_available
				fee_method
				epoch
				epoch_offset_hours
				enforced_capabilities
				version
				expected_lock_hours
				epoch_duration_days
				bracket_claim_address
				manager_claim_address
				nav_updater_address
				withdraw_delay_days
				kyc_required
				kyc_active
				kyc_tier
				kyc_templates
				kyb_available
				kyb_required
				kyb_min_tier
				kyb_templates
				morpho_url
				assoc_addresses {
					address
					type
					name
				}
				denomination {
					id
					name
					symbol
					logo
					label
					address
					decimals
					apy_prefix
					chainId
				}
				nav {
					epoch
					nav
					onav
					manager_tvl_fee
					bracket_tvl_fee
					manager_performance_fee
					updated
				}
				navs {
					epoch
					nav
					onav
					epoch_duration_days
				}
				manager {
					address
					user {
						email
						company
					}
				}
				transactions {
					trxn_type
					created
					nav
					shares
					amount_eq
					amount_brkt
					brkt_claimed
					finalized
					brkteth_conv
					price_btc
					price_eth
					finalized
					scheduled_time
					hash
					salt
					epoch_available
				}
				wrapper {
					address
					symbol
					logo
					label
					name
					decimals
				}
				morpho_data {
					lltv
					leverage
					leveragedYield
					borrowYield
				}
			}
		}
	}`;
};


export const BRKT_PRICE_PERIOD = (start: string, end: string) => `
{
	brkt_price_period(start:"${start}",end:"${end}") {
		date
		conv_rate
		eth_price
		brkt_eth_price
		brkt_supply
		total_value
	}
}

`;

export declare type ResultType = {
	VAULTS: {
		wallet: {
			vaults: IdentifiableVault[];
			managed_vaults: IdentifiableVault[];
		}
	};
	VAULT_DATA: {
		wallet: {
			vaults: Array<Vault
				& IVaultHasNav
				& IVaultHasNavs
				& IVaultHasAssocAddresses
				& IVaultHasManager
				& IVaultHasWrapper
				& IVaultHasTransactions
				& IVaultHasDenomination
				& IVaultHasChain
			>
		}
	},
	MANAGED_VAULT: {
		managed_vault: ( Vault
			& IVaultHasNav
			& IVaultHasNavs
			& IVaultHasAssocAddresses
			& IVaultHasManager
			& IVaultHasWrapper
			& IVaultHasTransactions
			& IVaultHasDenomination
			& IVaultHasChain
		)
	},
	MANAGED_VAULT_DATA: {
		wallet: {
			managed_vaults: Array<Vault
				& IVaultHasNav
				& IVaultHasNavs
				& IVaultHasAssocAddresses
				& IVaultHasManager
				& IVaultHasWrapper
				& IVaultHasTransactions
				& IVaultHasDenomination
				& IVaultHasChain
			>
		}
	},
	BRKT_PRICE_PERIOD: {
		brkt_price_period: {
			date: string;
			conv_rate: number;
			eth_price: number;
			brkt_eth_price: number;
			brkt_supply: number;
			total_value: number;
		}[]
	},
	PENNYWORKS_VAULT_POSITIONS: {
		vault: {
			address: Vault["address"];
			symbol: Vault["symbol"];
			pennyworks_positions: PennyworksPosition[];
		}
	}
}

